import { Button, ButtonStyles, FloatingSnackbar } from '@silverfort/sf-components';
import { INCIDENT_STATUS } from '@silverfort-nodelibs/common/utils/consts';
import { FC } from 'react';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    selectedIncidents: string[];
    onStatusChange: (incidentIds: string[], status: number) => void;
}

const IncidentStatusSnackbar: FC<Props> = ({ isOpen, onClose, selectedIncidents, onStatusChange }) => {
    const handleStatusChange = (newStatus: number) => {
        onStatusChange(selectedIncidents, newStatus);
        onClose();
    };

    return (
        <FloatingSnackbar
            onClose={onClose}
            selections={selectedIncidents.length}
            open={isOpen}
            children={
                <>
                    <Button
                        onClick={() => handleStatusChange(INCIDENT_STATUS.OPEN.value)}
                        buttonStyle={ButtonStyles.Ghost}
                        text={INCIDENT_STATUS.OPEN.label}
                    />
                    <Button
                        onClick={() => handleStatusChange(INCIDENT_STATUS.IN_PROGRESS.value)}
                        buttonStyle={ButtonStyles.Ghost}
                        text={INCIDENT_STATUS.IN_PROGRESS.label}
                    />
                    <Button
                        onClick={() => handleStatusChange(INCIDENT_STATUS.RESOLVED.value)}
                        buttonStyle={ButtonStyles.Ghost}
                        text={INCIDENT_STATUS.RESOLVED.label}
                    />
                </>
            }
            sx={{ position: 'absolute' }}
        />
    );
};

export default IncidentStatusSnackbar;
